/**
 * sl-yphr: ELSTER UI Gating Constants
 * sl-y2po.12: useElsterGate hook removed — plan+connectivity gate moved to ElsterGateProvider
 *
 * This file retains:
 * - ELSTER_ENABLED_CLASS: CSS class constant for the Lit<->React bridge
 * - isElsterEnabledFromBody(): Lit bridge function (used by sidebar-setup, mode-switch)
 *
 * The body class is toggled by ElsterGateProvider.
 */

/**
 * CSS class name added to body when ELSTER is plan-allowed AND configured.
 * Used by Lit components to check ELSTER state.
 */
export const ELSTER_ENABLED_CLASS = 'elster-enabled';

/**
 * Check if ELSTER is enabled by reading body class.
 * For use in Lit components and non-React code that can't use React hooks.
 */
export function isElsterEnabledFromBody(): boolean {
  return document.body.classList.contains(ELSTER_ENABLED_CLASS);
}
